import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Calendar, Mail, CheckCircle } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface QuickStatsCardProps {
  createdAt: string;
  totalMatches: number;
  acceptedMatches: number;
}

export function QuickStatsCard({ createdAt, totalMatches, acceptedMatches }: QuickStatsCardProps) {
  const daysSinceCreated = formatDistanceToNow(new Date(createdAt), { addSuffix: false });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Quick Stats</CardTitle>
        <CardDescription>
          Your matchmaking journey at a glance
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <Calendar className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">Member Since</p>
              <p className="text-xs text-muted-foreground">{daysSinceCreated} ago</p>
            </div>
          </div>

          <Separator />

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <Mail className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">Total Matches</p>
              <p className="text-xs text-muted-foreground">{totalMatches} received</p>
            </div>
          </div>

          <Separator />

          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <CheckCircle className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">Accepted</p>
              <p className="text-xs text-muted-foreground">{acceptedMatches} matches</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
